import {
    ScreenInfo,
    sideShortSizeMode,
    SideShortSizeMode,
    SubtitlesDirection,
    subtitlesDirection,
    SubtitlesRatio,
    subtitlesRatioValues,
} from './Subtitles.types';

const getShortSideSizeMode = (shortSide: number): SideShortSizeMode =>
    shortSide > 600 ? sideShortSizeMode.NORMAL : sideShortSizeMode.SMALL;

const getScreenCoef = (sizeMode: SideShortSizeMode, isVerticalOrientation = false): number => {
    const coef = sizeMode === sideShortSizeMode.NORMAL ? 5.2 : 5.5;

    return isVerticalOrientation ? coef - 1 : coef;
};

export const getScreenInfo = (): ScreenInfo => {
    const { innerHeight, innerWidth } = window;

    if (innerHeight > innerWidth) {
        const sizeMode = getShortSideSizeMode(innerWidth);
        return {
            shortSideSize: innerWidth,
            screenCoef: getScreenCoef(sizeMode, true),
            sizeMode,
        };
    }

    const sizeMode = getShortSideSizeMode(innerHeight);

    return {
        shortSideSize: innerHeight,
        screenCoef: getScreenCoef(sizeMode),
        sizeMode,
    };
};

export const isSubtitlesRatio = (num: Number): num is SubtitlesRatio =>
    Object.values(subtitlesRatioValues).includes(num as SubtitlesRatio);

export const getSubtitlesDirection = (lang: string): SubtitlesDirection => {
    const langPrefix = lang.split('-')[0];
    if (!langPrefix) {
        return subtitlesDirection.LTR;
    }

    const localeModel = new Intl.Locale(langPrefix);

    return (localeModel.textInfo?.direction ?? 'ltr') as SubtitlesDirection;
};
